import Notes from 'assets/icons/notes.svg';
import Atoms from 'assets/icons/atoms.svg';
import Search from 'assets/icons/search.svg';
import Wallet from 'assets/icons/wallet.svg';
import Combain from 'assets/icons/combain.svg';
import Measuring from 'assets/icons/Measuring.svg';
import Analytics from 'assets/icons/analytics.svg';

export const consultingPropsData = [
  {
    src: Analytics,
    title: 'Анализируем запрос',
    text: 'Проводим бесплатную консультацию, во время которой определяем боли и потребности бизнеса',
  },
  {
    src: Search,
    title: 'Проводим независимое исследование',
    text: 'Оцениваем нынешнее состояние системы, чтобы подготовить грамотную систему ИТ‑консультирования',
  },
  {
    src: Notes,
    title: 'Описываем план консультаций',
    text: 'В основу плана ложится информация, которую наши специалисты собрали во время исследования и первой консультации',
  },
  {
    src: Wallet,
    title: 'Согласуем стоимость услуг',
    text: 'Рассчитываем стоимость набора услуг, определяем количество, продолжительность и вид встреч',
  },
  {
    src: Atoms,
    title: 'Консультационные встречи',
    text: 'Во встречах участвуют две стороны: профильные специалисты ASTON, а также заказчик или его компетентные представители',
  },
  {
    src: Measuring,
    title: 'Контролируем результаты',
    text: 'Команда ASTON следит за тем, как внедрятся изменения и получает обратную связь от заказчика',
  },
  {
    src: Combain,
    title: 'Проводим консультации после запуска проекта',
    text: 'Договором может быть предусмотрено сопровождение после завершения работ',
    isLineVisible: false,
  },
].map((cardData, i) => ({ ...cardData, step: i + 1 }));
